export default "__VITE_ASSET__4edd6bf6__"